
import { BlogSection } from '@/types/blog';

export const emotionaleIntelligenzSection: BlogSection = {
  id: 'emotionale-intelligenz',
  title: 'KI und emotionale Intelligenz – ein starkes Duo',
  content: `
    <p>
      Ein entscheidender Faktor, der oft vergessen wird: Finanzielle Entscheidungen sind emotional. Als Finanzcoach begleite ich Menschen dabei, ihre finanziellen Ziele zu erreichen und gleichzeitig emotional ausgeglichen zu bleiben. Genau hier ergänzt KI die menschliche Komponente optimal.
    </p>

    <div class="my-8">
      <img 
        src="/images/blog/strand-balance.jpg" 
        alt="Person entspannt am Strand - Symbolbild für emotionale Balance" 
        class="rounded-lg w-full h-auto shadow-md" 
      />
      <p class="text-sm text-left mt-2 text-joerg-600">Emotionale Intelligenz ermöglicht Balance zwischen technologischem Fortschritt und persönlichem Wohlbefinden</p>
    </div>

    <p>
      Die emotionale Intelligenz befähigt dich, deine eigenen finanziellen Muster und emotionalen Trigger zu erkennen. Gleichzeitig sorgt die rationale Stärke der KI dafür, dass du datenbasiert und strategisch handeln kannst. Diese Kombination führt nicht nur zu besseren finanziellen Ergebnissen, sondern auch zu höherer Lebensqualität.
    </p>
  `
};
